// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__3B1yQ","topBottomGutter":"Layout_topBottomGutter__onYDq"};